import { LoadingButton } from '@mui/lab';
import { Box, Link as MuiLink, Paper, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { postDataFile } from 'src/api/oApi';
import { CopyToClipboardButton } from 'src/components/ui/CopyToClipboardButton';
import { Colors } from 'src/components/utils/Theme';
import { generalStore } from 'src/stores/GeneralStore';

export const FileUploadSite = () => {
  const [file, setFile] = useState<File | null>(null);
  const [url, setUrl] = useState<string | null>(null);
  const [isUploading, setIsUploading] = useState(false);

  const upload = async () => {
    if (!file) return;
    setIsUploading(true);
    setUrl(null);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const response = await postDataFile(formData);
      setUrl(response.data.data.url);
      generalStore.setMessage('File uploaded successfully');
    } catch (error: any) {
      generalStore.setError(
        error?.response?.data?.error?.message || error?.response?.data?.error || error?.message || 'Error uploading the file',
      );
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <>
      <Typography variant="h5" style={{ fontFamily: 'Aestetico-semibold', color: Colors.BLACK_BLUE }} sx={{ mb: 2 }}>
        File Upload
      </Typography>
      <Paper sx={{ p: 3, maxWidth: 640 }}>
        <Typography variant="body2" sx={{ mb: 2, color: Colors.GREY }}>
          Upload a file and get a hosted URL you can share.
        </Typography>
        <TextField
          fullWidth
          type="file"
          onChange={(event) => {
            const input = event.target as HTMLInputElement;
            setFile(input.files?.[0] ?? null);
            setUrl(null);
          }}
        />
        <LoadingButton loading={isUploading} disabled={!file} variant="contained" color="primary" sx={{ mt: 2 }} onClick={upload}>
          Upload
        </LoadingButton>
        {url ? (
          <Box sx={{ mt: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <TextField fullWidth label="File URL" value={url} InputProps={{ readOnly: true }} />
              <CopyToClipboardButton text={url} />
            </Box>
            <MuiLink href={url} target="_blank" rel="noreferrer" sx={{ display: 'inline-block', mt: 1 }}>
              Open file
            </MuiLink>
          </Box>
        ) : null}
      </Paper>
    </>
  );
};
